const e = ":export{screenBreakpointMedium:768;screenBreakpointLarge:1224}";
export {
  e as default
};
